import { useState } from "react";
import { useParams } from "react-router-dom";

import { StyledHubsPageContainer } from "../styles";

import { usePermissionContext } from "../../context/PermissionContext";
import { useGetCountryHubsQuery } from "../../sources/queries";

import { CloseReasonDialog } from "../../components/modals/CloseReasonDialog";
import { SearchHeader } from "../../components/SearchHeader";
import { HubInfo } from "../../components/HubInfo";
import { HubInfoSkeleton } from "../../components/placeholders/HubInfoSkeleton";
import { NoHubs } from "./NoHubs";
import EditEtaModal from "../../components/modals/EditEtaModal";

export const CountryHubs = () => {
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [hubInfo, setHubInfo] = useState({});
  const [openReason, setOpenReason] = useState(false);
  const [hubStatus, setHubStatus] = useState(null);

  const { hasEditETAPermission } = usePermissionContext();

  const onEditETA = (info) => {
    setOpen(true);
    setHubInfo(info);
  };
  const { code } = useParams();
  const { data, isLoading } = useGetCountryHubsQuery({
    refetchOnWindowFocus: false,
    cacheTime: 0,
    search,
  });
  const hubs = data?.data || [];

  const onCancel = () => {
    setOpenReason(false);
  };

  const onAction = ({ message }) => {
    const { variables, mutation } = hubStatus;
    mutation({ ...variables, message });
    setOpenReason(false);
  };

  const onHubStateChange = (variables, mutation) => {
    if (variables?.state === "OPEN") {
      mutation(variables);
    } else {
      setOpenReason(true);
      setHubStatus({ variables, mutation });
    }
  };

  return (
    <StyledHubsPageContainer maxWidth="lg">
      <SearchHeader
        header={`${code?.toUpperCase()} HUBS`}
        setSearch={setSearch}
      />
      <NoHubs
        hubs={hubs}
        isLoading={isLoading}
        message={`No hubs available for ${code?.toUpperCase()}`}
        showLink
      />
      {isLoading && (
        <>
          <HubInfoSkeleton />
          <HubInfoSkeleton />
        </>
      )}

      {hubs?.map((hub) => {
        return (
          <HubInfo
            key={hub.id}
            {...hub}
            onEditETA={onEditETA}
            onHubStateChange={onHubStateChange}
          />
        );
      })}
      {hasEditETAPermission && (
        <EditEtaModal open={open} setOpen={setOpen} hubInfo={hubInfo} />
      )}
      <CloseReasonDialog
        open={openReason}
        onCancel={onCancel}
        onAction={onAction}
        title={`Close ${hubStatus?.variables?.id} hub?`}
        message="If you sure you want to close this hub please choose the reason for closing."
        actionLabel="Close Hub"
        actionButtonProps={{ color: "primary" }}
      />
    </StyledHubsPageContainer>
  );
};
